<section>
    <!-- MODAL OVERLAY AND CONTAINER -->
    <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
        <div class="bg-white rounded-lg shadow-xl w-full max-w-md">
            <!-- MODAL HEADER -->
            <div class="flex justify-between items-center p-4 border-b">
                <h6 class="text-lg font-semibold">Service</h6>
                <button type="button" 
                        class="text-gray-500 hover:text-gray-700 focus:outline-none"
                        aria-label="Close" 
                        (click)="close()">
                    <span class="text-2xl">&times;</span>
                </button>
            </div>

            <!-- MODAL BODY -->
            <div class="p-6">
                <div class="space-y-4">
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-1">Confirmation #</label>
                        <input type="text" 
                               class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:text-gray-500"
                               placeholder="Enter confirmation number"
                               [(ngModel)]="view.service.confirmationCode" 
                               [disabled]="user.agentType == 'AGENT'">
                    </div>
                </div>
            </div>

            <!-- MODAL FOOTER -->
            <div class="flex justify-between p-4 border-t">
                <button *ngIf="user.agentType != 'AGENT'" 
                        type="button" 
                        class="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                        (click)="saveServiceItem()">
                    Save
                </button>
                <button type="button" 
                        class="px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-opacity-50"
                        (click)="close()">
                    Close
                </button>
            </div>
        </div>
    </div>
</section>